export const getProductName = (
  productName: string,
  productItemNumber: string,
  lifeCycleStatus: string,
  lifeCycleLabel: string
): string => {
  let pName = productName;

  if (productName && productItemNumber) {
    pName = productName + ' - ' + productItemNumber;
  }

  if (lifeCycleStatus === 'Obsolete') {
    pName = pName + ' - ' + lifeCycleLabel?.toUpperCase();
  }

  return pName;
};
